import type { ImageDocumentStoreItem } from '@v2/components/imageHandling/types/types';
import type { CropBounds } from '@v2/components/imageHandling/components/DrawingCanvas/types';

/** Builds the annotation-ready crop bounds from an image's stored cropSettings for a page. */
export const buildCropBounds = (image: ImageDocumentStoreItem, pageNumber: number): CropBounds | undefined => {
  const cs = image.cropSettings?.find((c) => c.pageNumber === pageNumber);
  if (!cs) return undefined;
  if (
    cs.upperLeftXPosition == null ||
    cs.lowerRightXPosition == null ||
    cs.upperLeftYPosition == null ||
    cs.lowerRightYPosition == null
  ) {
    return undefined;
  }
  return {
    upperLeftXPosition: cs.upperLeftXPosition,
    lowerRightXPosition: cs.lowerRightXPosition,
    upperLeftYPosition: cs.upperLeftYPosition,
    lowerRightYPosition: cs.lowerRightYPosition,
  };
};
